import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  withStyles,
  Icon,
  CircularProgress,
  Chip,
} from '@material-ui/core';
import {
  getEventUploadDownload,
  deleteUpload as deleteUploadAction,
  getEventUploadPreview,
} from '@pingum/app-state-management/eventUpload/actions';
// import Chip from '../Chip';
import styles from './styles';

const previewableFileRegex = /.png|jpeg|jpg|gif$/;

class EventUploadComponent extends React.Component {
  constructor(props) {
    super(props);

    const {
      eventUpload,
      downloadEventUploadPreview,
    } = props;

    this.state = {
      downloadedFile: null,
      previewable: eventUpload.fileName.match(previewableFileRegex),
    };

    if (this.state.previewable) {
      downloadEventUploadPreview(eventUpload.id, eventUpload.fileName).then((blob) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          const base64data = reader.result;
          this.setState({ downloadedFile: base64data });
        };
      });
    }
  }

  render() {
    const {
      eventUpload,
      editable,
      isDeletingEventUpload,
      downloadEventUpload,
      deleteUpload,
      classes,
      preview,
    } = this.props;

    const { previewable } = this.state;

    return (
      <div className={classes.container}>
        {
          !!previewable
            && !!preview
            && <img src={this.state.downloadedFile} alt={eventUpload.fileName} className={classes.imageUpload} />
        }
        <Chip
          onClick={() => downloadEventUpload(eventUpload.id, eventUpload.fileName)}
          icon={<Icon>get_app</Icon>}
          label={eventUpload.displayName}
          className={classes.chip}
          showDelete={editable}
          deleteIcon={
            isDeletingEventUpload
              ? <CircularProgress size={20} />
              : <Icon>delete</Icon>
          }
          onDelete={() => { deleteUpload(eventUpload.id); }}
        />
      </div>
    );
  }
}

EventUploadComponent.propTypes = {
  eventUpload: PropTypes.object,
  editable: PropTypes.bool,
  isDeletingEventUpload: PropTypes.bool,
  downloadEventUpload: PropTypes.func,
  deleteUpload: PropTypes.func,
  downloadEventUploadPreview: PropTypes.func,
  classes: PropTypes.object,
  preview: PropTypes.bool,
};

EventUploadComponent.defaultProps = {
  eventUpload: {},
  editable: false,
  isDeletingEventUpload: false,
  downloadEventUpload: () => {},
  deleteUpload: () => {},
  downloadEventUploadPreview: () => {},
  classes: {},
  preview: false,
};

export const mapStateToProps = (state) => ({ isDeletingEventUpload: state.eventUpload.isDeletingEventUpload });

export const mapDispatchToProps = (dispatch) => ({
  downloadEventUpload: (id, fileName) => dispatch(getEventUploadDownload(id, fileName)),
  downloadEventUploadPreview: (id, fileName) => dispatch(getEventUploadPreview(id, fileName)),
  deleteUpload: (id) => dispatch(deleteUploadAction(id)),
});

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(EventUploadComponent));
